import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import type { ExperimentalTouchpointSourceType } from '@trello/cross-flow';
import { ErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyDiscoveryAdPowerUpContainer: FunctionComponent<{
  source: ExperimentalTouchpointSourceType;
  workspaceId?: string;
}> = ({ source, workspaceId }) => {
  const DiscoveryAdPowerUpContainer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "discovery-ad-power-up" */ './DiscoveryAdPowerUpContainer'
      ),
    { preload: false, namedImport: 'DiscoveryAdPowerUpContainer' },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-web-eng',
          feature: 'Discovery Ad Powerup',
        }}
      >
        <DiscoveryAdPowerUpContainer
          source={source}
          workspaceId={workspaceId}
        />
      </ErrorBoundary>
    </Suspense>
  );
};
